<template>
  <div class="home-welcome-tab content-main">
    <div class="content-main__centered">
      <h4 class="appMain--text mb-2">Hello {{ userName }}!</h4>
      <p class="mb-4">
        <template v-if="currentUser">
          Welcome to your ConveYour dashboard, here is a brief overview of your
          account.
        </template>
        <template v-else> Welcome to ConveYour dashboard. </template>
      </p>

      <home-progress-bar />

      <template v-if="currentUser">
        <home-stats />

        <home-search />

        <home-onboarding-status />
      </template>

      <home-updates class="mt-8" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import HomeProgressBar from './HomeProgressBar.vue';
import HomeStats from './HomeStats';
import HomeSearch from './HomeSearch.vue';
import HomeOnboardingStatus from './HomeOnboardingStatus.vue';
import HomeUpdates from './HomeUpdates';

export default {
  name: 'HomeWelcomeTab',
  components: {
    HomeProgressBar,
    HomeStats,
    HomeSearch,
    HomeOnboardingStatus,
    HomeUpdates,
  },
  computed: {
    userName() {
      return this.currentUser?.first_name || '';
    },
    ...mapGetters('users', ['currentUser']),
  },
};
</script>
